<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            {{ $t("common.app_name") }}
          </h1>
          <ul
            class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
          >
            <li class="breadcrumb-item text-muted">
              <a
                href="../../demo1/dist/index.html"
                class="text-muted text-hover-primary"
                >{{ $t("common.home") }}</a
              >
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">{{ $t("menu.cart") }}</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
      </div>
    </div>
    <!-- Content -->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div
          v-if="isLoading == true"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
          class="loader text-success"
        >
          {{ $t("common.loading") }}
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">{{ $t("common.please_login_to_continue") }}</h3>
            <span>
              <a href="login" class="btn btn-success">
                {{ $t("common.login") }} <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>

        <div
          v-if="isLoggedIn == true"
          class="row g-5 g-xl-10 mb-5 mb-xl-10 cartContent"
        >
          <div
            class="col-xl-8 col-lg-8 col-md-12 cart-tb"
            style="display: none"
          >
            <div class="card">
              <div class="card-body">
                <hr />
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{{ $t("cart.course") }}</th>
                        <th>{{ $t("cart.course_title") }}</th>
                        <th></th>
                        <th>{{ $t("cart.price") }}</th>
                      </tr>
                    </thead>
                    <tbody id="cartTableBodyCourse">
                      <!-- Cart items will be dynamically added here -->
                    </tbody>
                  </table>
                  <hr />
                  <b>{{ $t("cart.bundles") }}</b>
                  <table class="table">
                    <tbody id="cartTableBodyBundle">
                      <!-- Cart items will be dynamically added here -->
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 cart-tb" style="display: none">
            <!-- Wallet Balance Card -->
            <div class="card card-body wallet-balance-card mb-3">
              <div class="wallet-balance-header">
                <div class="wallet-icon">
                  <i class="fas fa-wallet"></i>
                </div>
                <div class="wallet-info">
                  <span class="wallet-label">{{
                    $t("cart.wallet_balance") || "رصيد المحفظة"
                  }}</span>
                  <div class="wallet-amount">
                    <span v-if="isLoadingBalance" class="balance-loading">
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                      ></span>
                    </span>
                    <span
                      v-else-if="walletBalance !== null"
                      class="amount-value"
                    >
                      {{ walletBalance }} {{ $appCurrency }}
                    </span>
                    <span v-else class="amount-value">--</span>
                  </div>
                </div>
              </div>
              <router-link to="/Wallet" class="charge-wallet-link">
                <i class="fas fa-plus-circle"></i>
                {{ $t("cart.charge_wallet") || "شحن المحفظة" }}
              </router-link>
            </div>

            <div class="card card-body">
              <h4>
                <i class="fa fa-list"> </i> {{ $t("cart.invoice_title") }}
              </h4>
              <hr />
              <div
                class="cartInvoiceContainer"
                style="width: 100%; height: 100%"
              >
                <table class="table" id="cartInvoiceTable">
                  <tbody>
                    <tr>
                      <th>{{ $t("cart.offer_percent") }}:</th>
                      <td id="offerPercentCell">__</td>
                    </tr>
                    <tr>
                      <th>{{ $t("cart.coupon_discount") }}:</th>
                      <td id="couponDiscountCell">__</td>
                    </tr>
                    <tr>
                      <th>{{ $t("cart.total") }}:</th>
                      <td id="totalPriceCell">__</td>
                    </tr>
                  </tbody>
                </table>
                <div class="m-2">
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#applyCouponModal"
                    class="btn btn-sm btn-warning addCoupon"
                    style="display: none"
                  >
                    {{ $t("cart.use_coupon") }} <i class="fa fa-gift"></i>
                  </button>
                  <span id="removeCouponContainer"></span>
                </div>
              </div>
              <button
                href="#"
                class="btn btn-primary waves-effect waves-light"
                id="confirmPurchase"
                ref="confirmPurchase"
                @click="confirmPurchase"
              >
                {{ $t("checkout.confirm_button") }} <i class="fas fa-check"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Coupon />
</template>

<script>
import $ from "jquery";
import "twbs-pagination";
import { baseUrl, apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure
import Coupon from "./Coupon.vue";
import {
  showCart,
  confirmPurchase,
  removeCartItem,
  generateCartInvoice,
} from "@/utils/cart";
import { walletState, fetchBalance } from "@/stores/wallet";

export default {
  name: "Cart",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      respo: localStorage.getItem("respo"),
      baseUrl: baseUrl,
      isEmptyCart: false,
      isLoggedIn: false,
      isLoading: true,
      walletState,
    };
  },
  components: {
    Coupon,
  },
  computed: {
    walletBalance() {
      const balance = this.walletState.walletBalance;
      if (balance === null || balance === undefined) return null;
      return typeof balance === "number" ? balance.toFixed(2) : balance;
    },
    isLoadingBalance() {
      return this.walletState.loading;
    },
  },
  mounted() {
    if (localStorage.getItem("access_token")) {
      this.isLoggedIn = true;
      this.isLoading = false;
      this.showCart();
      var cartInvoiceTable = $("#cartInvoiceTable");
      this.generateCartInvoice(cartInvoiceTable);
      fetchBalance({ force: true });
    } else {
      this.isLoggedIn = false;
      this.isLoading = false;
    }
  },
  methods: {
    showCart,
    removeCartItem,
    generateCartInvoice,
    confirmPurchase() {
      const button = this.$refs.confirmPurchase;
      confirmPurchase($(button));
    },
  },
};
</script>

<style scoped>
/* ========== Toolbar ========== */
#kt_app_toolbar {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  border-bottom: 1px solid rgba(0, 196, 68, 0.1);
  box-shadow: 0 4px 20px rgba(0, 196, 68, 0.05);
}
.page-heading {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 1.5rem !important;
}

/* ========== Wallet Balance Card ========== */
.wallet-balance-card {
  background: linear-gradient(135deg, #e8fff1 0%, #d4f5e3 100%);
  border-radius: 20px;
  border: 2px solid #00c444;
  box-shadow: 0 10px 40px rgba(0, 196, 68, 0.15);
  position: relative;
  overflow: hidden;
}
.wallet-balance-card::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle,
    rgba(0, 196, 68, 0.05) 0%,
    transparent 70%
  );
  pointer-events: none;
}
.wallet-balance-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}
.wallet-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}
.wallet-icon i {
  color: white !important;
}
.wallet-info {
  flex: 1;
}
.wallet-label {
  font-size: 0.85rem;
  display: block;
  margin-bottom: 4px;
  color: #666 !important;
}
.wallet-amount {
  font-size: 1.5rem;
  font-weight: 700;
  color: #00a43c !important;
}
.wallet-amount .balance-loading {
  display: inline-flex;
  align-items: center;
}
.wallet-amount .amount-value {
  color: #00a43c !important;
}
.charge-wallet-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  color: white !important;
  padding: 10px 20px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}
.charge-wallet-link i {
  color: white !important;
}
.charge-wallet-link:hover {
  background: linear-gradient(135deg, #00a43c 0%, #008c32 100%);
  color: white !important;
  transform: translateY(-2px);
}

/* ========== Loader ========== */
.loader {
  border-radius: 24px !important;
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%) !important;
  border: 1px solid rgba(0, 196, 68, 0.1);
  box-shadow: 0 8px 32px rgba(0, 196, 68, 0.08);
  animation: loaderPulse 1.5s ease-in-out infinite;
}
@keyframes loaderPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* ========== Not Login / Empty Cart Card ========== */
.not-login {
  border-radius: 28px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fffe 100%);
  border: 2px dashed rgba(0, 196, 68, 0.2);
  box-shadow: 0 20px 60px rgba(0, 196, 68, 0.08);
  padding: 80px 40px !important;
  position: relative;
  overflow: hidden;
}
.not-login::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(0, 196, 68, 0.03) 0%,
    transparent 70%
  );
  animation: bgPulse 4s ease-in-out infinite;
}
@keyframes bgPulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
}
.not-login .icon {
  font-size: 6rem;
  background: linear-gradient(135deg, #00c444 0%, #00e050 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: block;
  margin-bottom: 24px;
  animation: iconFloat 3s ease-in-out infinite;
  position: relative;
  z-index: 1;
}
.not-login .icon::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 80px;
  background: radial-gradient(
    circle,
    rgba(0, 196, 68, 0.15) 0%,
    transparent 70%
  );
  border-radius: 50%;
  z-index: -1;
}
@keyframes iconFloat {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-15px) scale(1.05);
  }
}
.not-login h3 {
  color: #1a1a2e;
  font-weight: 800;
  font-size: 1.5rem;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}
.not-login p {
  color: #666;
  font-size: 1rem;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
}
.not-login .btn-success {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  border: none;
  border-radius: 999px;
  padding: 14px 36px;
  font-weight: 700;
  font-size: 1rem;
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.3);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.not-login .btn-success::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}
.not-login .btn-success:hover::before {
  left: 100%;
}
.not-login .btn-success:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 15px 40px rgba(0, 196, 68, 0.4);
}

/* ========== Empty Cart Specific ========== */
.cartContent .not-login .icon i.bi-inboxes {
  display: inline-block;
}
.cartContent .not-login::after {
  content: "🛒";
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 2rem;
  opacity: 0.15;
  animation: cartBounce 2s ease-in-out infinite;
}
@keyframes cartBounce {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-10px) rotate(5deg);
  }
}

/* ========== Beautiful Empty Cart Design ========== */
.empty-cart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  background: linear-gradient(145deg, #ffffff 0%, #f0fff5 50%, #e8fff0 100%);
  border-radius: 32px;
  border: 2px dashed rgba(0, 196, 68, 0.25);
  box-shadow: 0 20px 60px rgba(0, 196, 68, 0.1), 0 8px 24px rgba(0, 0, 0, 0.05),
    inset 0 -4px 20px rgba(0, 196, 68, 0.05);
  position: relative;
  overflow: hidden;
  animation: fadeInUp 0.6s ease-out;
}

.empty-cart-container::before {
  content: "";
  position: absolute;
  top: -100px;
  right: -100px;
  width: 300px;
  height: 300px;
  background: radial-gradient(
    circle,
    rgba(0, 196, 68, 0.08) 0%,
    transparent 70%
  );
  animation: floatBubble 6s ease-in-out infinite;
}

.empty-cart-container::after {
  content: "";
  position: absolute;
  bottom: -80px;
  left: -80px;
  width: 250px;
  height: 250px;
  background: radial-gradient(
    circle,
    rgba(0, 228, 84, 0.06) 0%,
    transparent 70%
  );
  animation: floatBubble 8s ease-in-out infinite reverse;
}

@keyframes floatBubble {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(20px, -20px) scale(1.1);
  }
}

/* Cart Icon Wrapper */
.empty-cart-illustration {
  position: relative;
  margin-bottom: 32px;
  z-index: 1;
}

.cart-icon-wrapper {
  position: relative;
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #00c444 0%, #00e854 50%, #00d048 100%);
  border-radius: 50%;
  box-shadow: 0 15px 40px rgba(0, 196, 68, 0.35),
    0 5px 15px rgba(0, 196, 68, 0.2), inset 0 -3px 10px rgba(0, 0, 0, 0.1),
    inset 0 3px 10px rgba(255, 255, 255, 0.3);
  animation: cartPulse 3s ease-in-out infinite;
}

.cart-icon-wrapper::before {
  content: "";
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  border: 3px dashed rgba(0, 196, 68, 0.3);
  animation: rotateBorder 15s linear infinite;
}

@keyframes rotateBorder {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes cartPulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 15px 40px rgba(0, 196, 68, 0.35),
      0 5px 15px rgba(0, 196, 68, 0.2);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 20px 50px rgba(0, 196, 68, 0.45),
      0 8px 20px rgba(0, 196, 68, 0.25);
  }
}

.cart-icon-wrapper > i {
  font-size: 3.5rem;
  color: white;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  animation: cartIconFloat 4s ease-in-out infinite;
}

@keyframes cartIconFloat {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-5px) rotate(-3deg);
  }
  75% {
    transform: translateY(3px) rotate(3deg);
  }
}

/* Sparkles */
.cart-sparkle {
  position: absolute;
  color: #ffd700;
  font-size: 1rem;
  animation: sparkleFloat 2s ease-in-out infinite;
}

.cart-sparkle i {
  filter: drop-shadow(0 0 4px rgba(255, 215, 0, 0.6));
}

.sparkle-1 {
  top: -10px;
  right: 10px;
  animation-delay: 0s;
}

.sparkle-2 {
  top: 20px;
  left: -15px;
  animation-delay: 0.5s;
  font-size: 0.8rem;
}

.sparkle-3 {
  bottom: 10px;
  right: -10px;
  animation-delay: 1s;
  font-size: 0.7rem;
}

@keyframes sparkleFloat {
  0%,
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  50% {
    transform: translateY(-8px) scale(1.2);
    opacity: 0.7;
  }
}

/* Content */
.empty-cart-content {
  text-align: center;
  z-index: 1;
}

.empty-cart-title {
  font-size: 2rem;
  font-weight: 800;
  background: linear-gradient(135deg, #00a43c 0%, #00c444 50%, #00e854 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.empty-cart-subtitle {
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 28px;
  font-weight: 500;
  max-width: 300px;
}

/* Browse Courses Button */
.browse-courses-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: linear-gradient(135deg, #00c444 0%, #00e854 50%, #00d048 100%);
  color: white;
  font-size: 1.1rem;
  font-weight: 700;
  border-radius: 50px;
  text-decoration: none;
  box-shadow: 0 10px 30px rgba(0, 196, 68, 0.35),
    0 4px 12px rgba(0, 196, 68, 0.2);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
}

.browse-courses-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.25),
    transparent
  );
  transition: left 0.6s ease;
}

.browse-courses-btn:hover::before {
  left: 100%;
}

.browse-courses-btn:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 15px 40px rgba(0, 196, 68, 0.45),
    0 6px 16px rgba(0, 196, 68, 0.25);
  color: white;
  text-decoration: none;
}

.browse-courses-btn .btn-text {
  display: flex;
  align-items: center;
}

.browse-courses-btn .btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transition: all 0.3s ease;
}

.browse-courses-btn:hover .btn-icon {
  background: rgba(255, 255, 255, 0.3);
  transform: translateX(-5px);
}

/* RTL Support */
[dir="rtl"] .browse-courses-btn .btn-icon {
  transform: scaleX(-1);
}

[dir="rtl"] .browse-courses-btn:hover .btn-icon {
  transform: scaleX(-1) translateX(-5px);
}

/* Responsive */
@media (max-width: 768px) {
  .empty-cart-container {
    padding: 40px 24px;
    margin: 0 12px;
  }

  .cart-icon-wrapper {
    width: 110px;
    height: 110px;
  }

  .cart-icon-wrapper > i {
    font-size: 2.8rem;
  }

  .empty-cart-title {
    font-size: 1.6rem;
  }

  .empty-cart-subtitle {
    font-size: 1rem;
  }

  .browse-courses-btn {
    padding: 14px 24px;
    font-size: 1rem;
  }
}

/* Dark Mode Support */
[data-bs-theme="dark"] .empty-cart-container,
[data-theme="dark"] .empty-cart-container,
.dark .empty-cart-container {
  background: linear-gradient(145deg, #1a1b1e 0%, #1e2a22 50%, #1a2520 100%);
  border-color: rgba(0, 196, 68, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 8px 24px rgba(0, 0, 0, 0.2),
    inset 0 -4px 20px rgba(0, 196, 68, 0.05);
}

[data-bs-theme="dark"] .empty-cart-subtitle,
[data-theme="dark"] .empty-cart-subtitle,
.dark .empty-cart-subtitle {
  color: #9ca3af;
}

/* ========== Cart Content ========== */
.cartContent {
  animation: fadeInUp 0.5s ease;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ========== Cart Card ========== */
.cart-tb .card {
  border-radius: 24px !important;
  background: linear-gradient(145deg, #ffffff 0%, #fafffe 100%);
  border: 1px solid rgba(0, 196, 68, 0.1) !important;
  box-shadow: 0 10px 40px rgba(0, 196, 68, 0.08) !important;
  overflow: hidden;
  position: relative;
}
.cart-tb .card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #00c444, #00e050, #00c444);
  background-size: 200% 100%;
  animation: gradientSlide 3s linear infinite;
}
@keyframes gradientSlide {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}

.cart-tb .card-body {
  padding: 24px;
}

/* ========== Table Container ========== */
.table-responsive {
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%);
  border-radius: 20px;
  padding: 20px;
  border: 1px solid rgba(0, 196, 68, 0.1);
}

/* ========== Table ========== */
.table {
  border-collapse: separate;
  border-spacing: 0 12px;
  margin-bottom: 0;
}

/* ========== Table Header ========== */
.table thead {
  position: relative;
}
.table thead th {
  background: transparent;
  color: #00a43c;
  font-weight: 800;
  padding: 16px;
  border: none;
  border-bottom: 3px solid #00c444;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
}
.table thead th::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #00e050, #00c444);
  transition: width 0.3s ease;
}
.table thead th:hover::before {
  width: 100%;
}

/* ========== Table Body ========== */
.table tbody tr {
  background: linear-gradient(145deg, #ffffff 0%, #fafffe 100%);
  box-shadow: 0 4px 20px rgba(0, 196, 68, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border-radius: 16px;
}
.table tbody tr:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 12px 35px rgba(0, 196, 68, 0.15);
}
.table tbody td {
  padding: 18px 16px;
  vertical-align: middle;
  border: none;
  color: #1a1a2e;
  font-weight: 500;
  background: transparent;
}
.table tbody td:first-child {
  border-radius: 16px 0 0 16px;
  font-weight: 800;
  font-size: 1.1rem;
  color: #00c444;
  text-align: center;
  width: 60px;
}
.table tbody td:last-child {
  border-radius: 0 16px 16px 0;
}

/* ========== Row Number Badge ========== */
.table tbody td:first-child::before {
  content: "";
  display: inline-block;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  border-radius: 10px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
}

/* ========== Course Title Column ========== */
.table tbody td:nth-child(3) {
  font-weight: 700;
  color: #1a1a2e;
  max-width: 250px;
}

/* ========== Coupon Column ========== */
.table tbody td:nth-child(4) .text-success {
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e2 100%);
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.85rem;
  display: inline-block;
}

/* ========== Cart Item Image ========== */
.table tbody td img {
  border-radius: 12px;
  border: 2px solid rgba(0, 196, 68, 0.15);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}
.table tbody tr:hover td img {
  transform: scale(1.05);
  border-color: rgba(0, 196, 68, 0.3);
}

/* ========== Amount ========== */
.amount-cart {
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e2 100%);
  color: #00a43c;
  padding: 8px 16px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.95rem;
  display: inline-block;
}

/* ========== Remove Button ========== */
.remove-button {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%) !important;
  color: #dc3545 !important;
  border: 1px solid rgba(220, 53, 69, 0.2) !important;
  border-radius: 10px !important;
  padding: 8px 12px !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.remove-button:hover {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
  color: #fff !important;
  border-color: transparent !important;
  transform: scale(1.1) !important;
}

/* ========== Invoice Card ========== */
.col-xl-4 .card {
  border-radius: 24px !important;
  background: linear-gradient(145deg, #ffffff 0%, #fafffe 100%);
  border: 1px solid rgba(0, 196, 68, 0.1) !important;
  box-shadow: 0 10px 40px rgba(0, 196, 68, 0.08) !important;
  position: sticky;
  top: 100px;
  overflow: hidden;
}
.col-xl-4 .card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #00c444, #00e050, #00c444);
  background-size: 200% 100%;
  animation: gradientSlide 3s linear infinite;
}
.col-xl-4 .card-body {
  padding: 18px;
}
.col-xl-4 .card h4 {
  color: #1a1a2e;
  font-weight: 800;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(0, 196, 68, 0.1);
}
.col-xl-4 .card h4 i {
  width: 34px;
  height: 34px;
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  color: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  box-shadow: 0 4px 12px rgba(0, 196, 68, 0.25);
}

/* ========== Invoice Container ========== */
.cartInvoiceContainer {
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%);
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 14px;
  border: 1px solid rgba(0, 196, 68, 0.1);
}

/* ========== Invoice Table ========== */
#cartInvoiceTable {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}
#cartInvoiceTable tr {
  transition: all 0.3s ease;
}
#cartInvoiceTable tr:not(:last-child) {
  border-bottom: 1px dashed rgba(0, 196, 68, 0.15);
}
#cartInvoiceTable tr:hover:not(:last-child) {
  background: rgba(0, 196, 68, 0.03);
}
#cartInvoiceTable th {
  color: #666;
  font-weight: 600;
  padding: 10px 8px;
  font-size: 0.9rem;
}

[dir="rtl"] #cartInvoiceTable th {
  text-align: right;
}

[dir="ltr"] #cartInvoiceTable th {
  text-align: left;
}
[dir="rtl"] #cartInvoiceTable th::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  border-radius: 50%;
  margin-left: 6px;
}

[dir="ltr"] #cartInvoiceTable th::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  border-radius: 50%;
  margin-right: 6px;
}
#cartInvoiceTable td {
  color: #1a1a2e;
  font-weight: 700;
  padding: 10px 8px;
  font-size: 0.95rem;
}

[dir="rtl"] #cartInvoiceTable td {
  text-align: left;
}

[dir="ltr"] #cartInvoiceTable td {
  text-align: right;
}

/* ========== Total Row ========== */
#cartInvoiceTable tr:last-child {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  border-radius: 10px;
  margin-top: 8px;
}
#cartInvoiceTable tr:last-child th,
#cartInvoiceTable tr:last-child td {
  color: #fff !important;
  font-size: 1rem;
  font-weight: 800;
  padding: 12px 10px;
}
#cartInvoiceTable tr:last-child th::before {
  background: rgba(255, 255, 255, 0.3);
}
[dir="rtl"] #cartInvoiceTable tr:last-child th:first-child {
  border-radius: 0 10px 10px 0;
}

[dir="rtl"] #cartInvoiceTable tr:last-child td:last-child {
  border-radius: 10px 0 0 10px;
}

[dir="ltr"] #cartInvoiceTable tr:last-child th:first-child {
  border-radius: 10px 0 0 10px;
}

[dir="ltr"] #cartInvoiceTable tr:last-child td:last-child {
  border-radius: 0 10px 10px 0;
}

/* ========== Coupon Button ========== */
.addCoupon {
  background: linear-gradient(135deg, #ffc107 0%, #ffb300 100%) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3) !important;
  transition: all 0.3s ease !important;
}
.addCoupon:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(255, 193, 7, 0.4) !important;
}
.addCoupon i {
  animation: giftShake 2s ease-in-out infinite;
}
@keyframes giftShake {
  0%,
  100% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(-10deg);
  }
  75% {
    transform: rotate(10deg);
  }
}

/* ========== Confirm Purchase Button ========== */
#confirmPurchase {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  border: none !important;
  border-radius: 14px !important;
  padding: 16px 24px !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.3) !important;
  transition: all 0.3s ease !important;
  position: relative;
  overflow: hidden;
}
#confirmPurchase::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}
#confirmPurchase:hover::before {
  left: 100%;
}
#confirmPurchase:hover {
  transform: translateY(-3px) !important;
  box-shadow: 0 12px 35px rgba(0, 196, 68, 0.4) !important;
}

/* ========== Bundles Section ========== */
.card-body b {
  color: #00c444;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}
.card-body b::before {
  content: "📦";
}

/* ========== HR ========== */
hr {
  border-color: rgba(0, 196, 68, 0.1);
  margin: 20px 0;
}

/* ========== Scrollbar ========== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #f0fff5;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #00c444 0%, #00a43c 100%);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #00d44a 0%, #00b844 100%);
}

/* ========== Responsive ========== */
@media (max-width: 768px) {
  .cart-tb .card,
  .col-xl-4 .card {
    border-radius: 18px !important;
  }
  .table thead th,
  .table tbody td {
    padding: 12px 8px;
    font-size: 0.85rem;
  }
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] #kt_app_toolbar,
[data-theme="dark"] #kt_app_toolbar,
.dark #kt_app_toolbar {
  background: linear-gradient(135deg, #1a1b1d 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .page-heading,
[data-theme="dark"] .page-heading,
.dark .page-heading {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-bs-theme="dark"] .loader,
[data-theme="dark"] .loader,
.dark .loader {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%) !important;
  border-color: rgba(0, 196, 68, 0.15);
  color: #00e050 !important;
}

[data-bs-theme="dark"] .not-login,
[data-theme="dark"] .not-login,
.dark .not-login {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%);
  border-color: rgba(0, 196, 68, 0.25);
}
[data-bs-theme="dark"] .not-login::before,
[data-theme="dark"] .not-login::before,
.dark .not-login::before {
  background: radial-gradient(
    circle,
    rgba(0, 196, 68, 0.05) 0%,
    transparent 70%
  );
}
[data-bs-theme="dark"] .not-login .icon,
[data-theme="dark"] .not-login .icon,
.dark .not-login .icon {
  background: linear-gradient(135deg, #00e050 0%, #8bffb3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
[data-bs-theme="dark"] .not-login .icon::after,
[data-theme="dark"] .not-login .icon::after,
.dark .not-login .icon::after {
  background: radial-gradient(
    circle,
    rgba(0, 196, 68, 0.2) 0%,
    transparent 70%
  );
}
[data-bs-theme="dark"] .not-login h3,
[data-theme="dark"] .not-login h3,
.dark .not-login h3 {
  color: #e4e6eb;
}
[data-bs-theme="dark"] .not-login p,
[data-theme="dark"] .not-login p,
.dark .not-login p {
  color: #b0b3b8;
}
[data-bs-theme="dark"] .cartContent .not-login::after,
[data-theme="dark"] .cartContent .not-login::after,
.dark .cartContent .not-login::after {
  opacity: 0.25;
}

[data-bs-theme="dark"] .cart-tb .card,
[data-bs-theme="dark"] .col-xl-4 .card,
[data-theme="dark"] .cart-tb .card,
[data-theme="dark"] .col-xl-4 .card,
.dark .cart-tb .card,
.dark .col-xl-4 .card {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%);
  border-color: rgba(0, 196, 68, 0.15) !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3) !important;
}

/* Table Container Dark Mode */
[data-bs-theme="dark"] .table-responsive,
[data-theme="dark"] .table-responsive,
.dark .table-responsive {
  background: linear-gradient(145deg, #2d2e30 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.15);
}

/* Table Header Dark Mode */
[data-bs-theme="dark"] .table thead th,
[data-theme="dark"] .table thead th,
.dark .table thead th {
  color: #00e050;
  border-bottom-color: #00e050;
}
[data-bs-theme="dark"] .table thead th::before,
[data-theme="dark"] .table thead th::before,
.dark .table thead th::before {
  background: linear-gradient(90deg, #00e050, #8bffb3);
}

/* Table Body Dark Mode */
[data-bs-theme="dark"] .table tbody tr,
[data-theme="dark"] .table tbody tr,
.dark .table tbody tr {
  background: linear-gradient(145deg, #2d2e30 0%, #242526 100%);
}
[data-bs-theme="dark"] .table tbody tr:hover,
[data-theme="dark"] .table tbody tr:hover,
.dark .table tbody tr:hover {
  box-shadow: 0 12px 35px rgba(0, 196, 68, 0.2);
}
[data-bs-theme="dark"] .table tbody td,
[data-theme="dark"] .table tbody td,
.dark .table tbody td {
  color: #e4e6eb;
}
[data-bs-theme="dark"] .table tbody td:first-child,
[data-theme="dark"] .table tbody td:first-child,
.dark .table tbody td:first-child {
  color: #00e050;
}

/* Coupon Column Dark Mode */
[data-bs-theme="dark"] .table tbody td:nth-child(4) .text-success,
[data-theme="dark"] .table tbody td:nth-child(4) .text-success,
.dark .table tbody td:nth-child(4) .text-success {
  background: linear-gradient(135deg, #1a3d2a 0%, #1e4d35 100%);
  color: #8bffb3;
}

[data-bs-theme="dark"] .amount-cart,
[data-theme="dark"] .amount-cart,
.dark .amount-cart {
  background: linear-gradient(135deg, #1a3d2a 0%, #1e4d35 100%);
  color: #8bffb3;
}

/* Invoice Card Dark Mode */
[data-bs-theme="dark"] .col-xl-4 .card h4,
[data-theme="dark"] .col-xl-4 .card h4,
.dark .col-xl-4 .card h4 {
  color: #e4e6eb;
  border-bottom-color: rgba(0, 196, 68, 0.2);
}
[data-bs-theme="dark"] .col-xl-4 .card h4 i,
[data-theme="dark"] .col-xl-4 .card h4 i,
.dark .col-xl-4 .card h4 i {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%);
  color: #fff;
}

/* Invoice Container Dark Mode */
[data-bs-theme="dark"] .cartInvoiceContainer,
[data-theme="dark"] .cartInvoiceContainer,
.dark .cartInvoiceContainer {
  background: linear-gradient(145deg, #2d2e30 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.15);
}

/* Invoice Table Dark Mode */
[data-bs-theme="dark"] #cartInvoiceTable tr:not(:last-child),
[data-theme="dark"] #cartInvoiceTable tr:not(:last-child),
.dark #cartInvoiceTable tr:not(:last-child) {
  border-color: rgba(0, 196, 68, 0.15);
}
[data-bs-theme="dark"] #cartInvoiceTable tr:hover:not(:last-child),
[data-theme="dark"] #cartInvoiceTable tr:hover:not(:last-child),
.dark #cartInvoiceTable tr:hover:not(:last-child) {
  background: rgba(0, 196, 68, 0.05);
}
[data-bs-theme="dark"] #cartInvoiceTable th,
[data-theme="dark"] #cartInvoiceTable th,
.dark #cartInvoiceTable th {
  color: #b0b3b8;
}
[data-bs-theme="dark"] #cartInvoiceTable th::before,
[data-theme="dark"] #cartInvoiceTable th::before,
.dark #cartInvoiceTable th::before {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%);
}
[data-bs-theme="dark"] #cartInvoiceTable td,
[data-theme="dark"] #cartInvoiceTable td,
.dark #cartInvoiceTable td {
  color: #e4e6eb;
}

/* Total Row Dark Mode */
[data-bs-theme="dark"] #cartInvoiceTable tr:last-child,
[data-theme="dark"] #cartInvoiceTable tr:last-child,
.dark #cartInvoiceTable tr:last-child {
  background: linear-gradient(135deg, #00a43c 0%, #008833 100%);
}
[data-bs-theme="dark"] #cartInvoiceTable tr:last-child th,
[data-bs-theme="dark"] #cartInvoiceTable tr:last-child td,
[data-theme="dark"] #cartInvoiceTable tr:last-child th,
[data-theme="dark"] #cartInvoiceTable tr:last-child td,
.dark #cartInvoiceTable tr:last-child th,
.dark #cartInvoiceTable tr:last-child td {
  color: #fff !important;
}
[data-bs-theme="dark"] #cartInvoiceTable tr:last-child th::before,
[data-theme="dark"] #cartInvoiceTable tr:last-child th::before,
.dark #cartInvoiceTable tr:last-child th::before {
  background: rgba(255, 255, 255, 0.4);
}

[data-bs-theme="dark"] hr,
[data-theme="dark"] hr,
.dark hr {
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .card-body b,
[data-theme="dark"] .card-body b,
.dark .card-body b {
  color: #00e050;
}

[data-bs-theme="dark"] .breadcrumb-item.text-muted,
[data-theme="dark"] .breadcrumb-item.text-muted,
.dark .breadcrumb-item.text-muted {
  color: #b0b3b8 !important;
}
[data-bs-theme="dark"] .breadcrumb-item a,
[data-theme="dark"] .breadcrumb-item a,
.dark .breadcrumb-item a {
  color: #00e050 !important;
}

[data-bs-theme="dark"] ::-webkit-scrollbar-track,
[data-theme="dark"] ::-webkit-scrollbar-track,
.dark ::-webkit-scrollbar-track {
  background: #242526;
}
</style>
